// extracted by mini-css-extract-plugin
export var comment = "index-module--comment--bo0Uq";
export var inner = "index-module--inner--qCVRq";
export var people = "index-module--people--CPnpe";
export var swiperContent = "index-module--swiperContent---SQtG";
export var theirComment = "index-module--theirComment--nKuyG";